export function uniqueFormMessages(errors) {
    return [...new Set(errors.map(error => error.message))];
}

export function prepareAdvertiserModalForm(form) {
    if (!form.closest('.modal')) {
        return;
    }

    form.classList.add('ajax');
    form.setAttribute('data-naja-force-redirect', '');
}

export function configureAdvertiserForms(netteForms) {
    const defaultShowFormErrors = netteForms.showFormErrors.bind(netteForms);

    netteForms.showFormErrors = (form, errors) => {
        if (!form.closest('.modal')) {
            defaultShowFormErrors(form, errors);
            return;
        }

        let container = form.querySelector('.form-errors');
        if (errors.length === 0) {
            container?.remove();
            return;
        }

        if (!container) {
            container = form.ownerDocument.createElement('div');
            container.className = 'form-errors';
            form.prepend(container);
        }

        let alert = container.querySelector('.alert.alert-danger.errors');
        if (!alert) {
            alert = form.ownerDocument.createElement('div');
            alert.className = 'alert alert-danger errors';
            container.append(alert);
        }

        alert.replaceChildren(...uniqueFormMessages(errors).map(message => {
            const line = form.ownerDocument.createElement('span');
            line.textContent = message;
            return line;
        }));
        errors[0]?.element?.focus();
    };
}
